<template>
  <div class="category-admin">
    <v-card>
      <v-card-title data-cy="title">
        Categories
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          :prepend-icon="svgMagnify"
          label="Search"
          clearable
          style="margin-left:250px;"
        ></v-text-field>
      </v-card-title>

      <v-card-actions class="mb-1">
        <v-spacer></v-spacer>
        <v-btn data-cy="plus-btn" text @click="addCategory()">
          <v-icon>
            {{ svgPlus }}
          </v-icon>
        </v-btn>
      </v-card-actions>

      <v-data-table :headers="headers" :items="items" :search="search" :items-per-page="5" class="elevation-1">
        <template v-slot:item.action="{ item }">
          <v-icon @click="editItem(item)">
            {{ svgPencil }}
          </v-icon>
          <v-icon @click="deleteItem(item)">
            {{ svgDelete }}
          </v-icon>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="dialog" width="500" persistent>
      <v-card v-if="selectedCategory">
        <v-card-title class="text-h5 grey lighten-2" primary-title> Delete - {{ selectedCategory.name }} </v-card-title>

        <v-card-text>
          Press OK to delete this category.
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="deleteCategory()">OK</v-btn>
          <v-btn color="primary" text @click="dialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { mdiPencil, mdiDelete } from "@mdi/js";
import { mdiMagnify } from "@mdi/js";
import { mdiPlus } from "@mdi/js";

export default {
  name: "Categories",
  components: {},
  data: () => {
    return {
      search: "",
      svgPlus: mdiPlus,
      svgMagnify: mdiMagnify,
      svgPencil: mdiPencil,
      svgDelete: mdiDelete,
      dialog: false,
      selectedCategory: null,
      pagination: {
        sortBy: "name",
        descending: true,
        rowsPerPage: 5,
      },
      headers: [
        { text: "ID", value: "id" },
        {
          text: "Category",
          align: "left",
          value: "name",
          "must-sort": true,
        },
        {
          text: "Description",
          align: "left",
          value: "description",
          "must-sort": true,
        },
        { text: "Action", value: "action", sortable: false, width: "10%" },
      ],
    };
  },
  beforeCreate() {},

  created() {
    this.$store.dispatch("getCategoryList");
    this.$store.dispatch("getUomList");
  },

  mounted() {},

  beforeDestroy() {},

  computed: {
    ...mapGetters({
      items: "getCategoryList",
    }),
  },

  methods: {
    deleteItem(item) {
      if (!item) {
        return;
      }
      this.selectedCategory = item;
      this.dialog = true;
    },
    deleteCategory() {
      this.dialog = false;
      if (!this.selectedCategory) {
        return;
      }
      this.$store.dispatch("deleteCategory", this.selectedCategory);
    },
    editItem(item) {
      if (!item) {
        return;
      }
      this.selectedCategory = item;
      this.$store.dispatch("selectedCategory", item);
      this.$router.push({ name: "CategoryDetails" });
    },
    addCategory() {
      this.$store.dispatch("selectedCategory", null);
      this.$router.push({ name: "CategoryDetails" });
    },
  },
};
</script>

<style lang="scss">
.category-admin {
}
</style>
